import React, { useCallback } from 'react'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import Geolocations from '../../../../../../ReusableFormFields/GeolocationsFields'

import { DV_360_PLATFORM } from '../../../../../../../constants/selectLists/platformList'
import { SHOW_COUNTRIES, SHOW_REGIONS } from '../../../../../../ReusableFormFields/GeolocationsFields/fields'

const stepFields = [SHOW_COUNTRIES, SHOW_REGIONS]

const GeolocationStep = ({ formik, handleStepChange }) => {
  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="Please select a location or locations" handleContinue={handleContinue}>
      <Geolocations
        showRegionsCountryFilter={false}
        showCustomLocations={false}
        showWorldwide={false}
        formik={formik}
        platform={DV_360_PLATFORM}
      />
    </Step>
  )
}

export default GeolocationStep
